import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u041C\u043E\u043D\u0433\u043E\u043B",
  code: "mn",
  messages: {
    alert: {
      close: "\u0425\u0430\u0430\u0445"
    },
    authForm: {
      hidePassword: "\u041D\u0443\u0443\u0446 \u04AF\u0433\u0438\u0439\u0433 \u043D\u0443\u0443\u0445",
      showPassword: "\u041D\u0443\u0443\u0446 \u04AF\u0433\u0438\u0439\u0433 \u0445\u0430\u0440\u0443\u0443\u043B\u0430\u0445",
      submit: "\u04AE\u0440\u0433\u044D\u043B\u0436\u043B\u04AF\u04AF\u043B\u044D\u0445"
    },
    banner: {
      close: "\u0425\u0430\u0430\u0445"
    },
    calendar: {
      nextMonth: "\u0414\u0430\u0440\u0430\u0430 \u0441\u0430\u0440",
      nextYear: "\u0414\u0430\u0440\u0430\u0430 \u0436\u0438\u043B",
      prevMonth: "\u04E8\u043C\u043D\u04E9\u0445 \u0441\u0430\u0440",
      prevYear: "\u04E8\u043C\u043D\u04E9\u0445 \u0436\u0438\u043B"
    },
    carousel: {
      dots: "\u0425\u0430\u0440\u0443\u0443\u043B\u0430\u0445 \u0441\u043B\u0430\u0439\u0434\u044B\u0433 \u0441\u043E\u043D\u0433\u043E\u043D\u043E \u0443\u0443",
      goto: "{slide}-\u0440 \u0445\u0443\u0443\u0434\u0441\u0430\u043D\u0434 \u0448\u0438\u043B\u0436\u0438\u0445",
      next: "\u0414\u0430\u0440\u0430\u0430\u0445",
      prev: "\u04E8\u043C\u043D\u04E9\u0445"
    },
    chatPrompt: {
      placeholder: "\u042D\u043D\u0434 \u043C\u0435\u0441\u0441\u0435\u0436\u044D\u044D \u0431\u0438\u0447\u043D\u044D \u04AF\u04AF..."
    },
    chatPromptSubmit: {
      label: "\u041C\u0435\u0441\u0441\u0435\u0436 \u0438\u043B\u0433\u044D\u044D\u0445"
    },
    colorMode: {
      dark: "\u0425\u0430\u0440",
      light: "\u0426\u0430\u0433\u0430\u0430\u043D",
      switchToDark: "\u0425\u0430\u0440 \u0433\u043E\u0440\u0438\u043C\u0434 \u0448\u0438\u043B\u0436\u0438\u0445",
      switchToLight: "\u0426\u0430\u0433\u0430\u0430\u043D \u0433\u043E\u0440\u0438\u043C\u0434 \u0448\u0438\u043B\u0436\u0438\u0445",
      system: "\u0421\u0438\u0441\u0442\u0435\u043C"
    },
    commandPalette: {
      back: "\u0411\u0443\u0446\u0430\u0445",
      close: "\u0425\u0430\u0430\u0445",
      noData: "\u041C\u044D\u0434\u044D\u044D\u043B\u044D\u043B \u0431\u0430\u0439\u0445\u0433\u04AF\u0439",
      noMatch: "\u0422\u043E\u0445\u0438\u0440\u043E\u0445 \u043C\u044D\u0434\u044D\u044D\u043B\u044D\u043B \u043E\u043B\u0434\u0441\u043E\u043D\u0433\u04AF\u0439",
      placeholder: "\u041A\u043E\u043C\u043C\u0430\u043D\u0434 \u0431\u0438\u0447\u0438\u0445 \u044D\u0441\u0432\u044D\u043B \u0445\u0430\u0439\u043B\u0442 \u0445\u0438\u0439\u0445..."
    },
    contentSearch: {
      links: "\u0425\u043E\u043B\u0431\u043E\u043E\u0441\u0443\u0443\u0434",
      theme: "\u0417\u0430\u0433\u0432\u0430\u0440"
    },
    contentSearchButton: {
      label: "\u0425\u0430\u0439\u0445..."
    },
    contentToc: {
      title: "\u042D\u043D\u044D \u0445\u0443\u0443\u0434\u0441\u0430\u043D\u0434"
    },
    dashboardSearch: {
      theme: "\u0417\u0430\u0433\u0432\u0430\u0440"
    },
    dashboardSearchButton: {
      label: "\u0425\u0430\u0439\u0445..."
    },
    dashboardSidebarCollapse: {
      collapse: "\u0425\u0430\u0436\u0443\u0443\u0433\u0438\u0439\u043D \u0441\u0430\u043C\u0431\u0430\u0440\u044B\u0433 \u0445\u0443\u0440\u0430\u0430\u0445",
      expand: "\u0425\u0430\u0436\u0443\u0443\u0433\u0438\u0439\u043D \u0441\u0430\u043C\u0431\u0430\u0440\u044B\u0433 \u0434\u044D\u043B\u0433\u044D\u0445"
    },
    dashboardSidebarToggle: {
      close: "\u0425\u0430\u0436\u0443\u0443\u0433\u0438\u0439\u043D \u0441\u0430\u043C\u0431\u0430\u0440\u044B\u0433 \u0445\u0430\u0430\u0445",
      open: "\u0425\u0430\u0436\u0443\u0443\u0433\u0438\u0439\u043D \u0441\u0430\u043C\u0431\u0430\u0440\u044B\u0433 \u043D\u044D\u044D\u0445"
    },
    error: {
      clear: "\u041D\u04AF\u04AF\u0440 \u0445\u0443\u0443\u0434\u0430\u0441 \u0440\u0443\u0443 \u0431\u0443\u0446\u0430\u0445"
    },
    fileUpload: {
      removeFile: "{filename} \u0443\u0441\u0442\u0433\u0430\u0445"
    },
    header: {
      close: "\u0426\u044D\u0441\u0438\u0439\u0433 \u0445\u0430\u0430\u0445",
      open: "\u0426\u044D\u0441\u0438\u0439\u0433 \u043D\u044D\u044D\u0445"
    },
    inputMenu: {
      create: '"{label}" \u04AF\u04AF\u0441\u0433\u044D\u0445',
      noData: "\u041C\u044D\u0434\u044D\u044D\u043B\u044D\u043B \u0431\u0430\u0439\u0445\u0433\u04AF\u0439",
      noMatch: "\u0422\u043E\u0445\u0438\u0440\u043E\u0445 \u043C\u044D\u0434\u044D\u044D\u043B\u044D\u043B \u043E\u043B\u0434\u0441\u043E\u043D\u0433\u04AF\u0439"
    },
    inputNumber: {
      decrement: "\u0425\u0430\u0441\u0430\u0445",
      increment: "\u041D\u044D\u043C\u044D\u0445"
    },
    modal: {
      close: "\u0425\u0430\u0430\u0445"
    },
    pricingTable: {
      caption: "\u04AE\u043D\u0438\u0439\u043D \u0442\u04E9\u043B\u04E9\u0432\u043B\u04E9\u0433\u04E9\u04E9\u043D\u0438\u0439 \u0445\u0430\u0440\u044C\u0446\u0443\u0443\u043B\u0430\u043B\u0442"
    },
    prose: {
      codeCollapse: {
        closeText: "\u0425\u0443\u0440\u0430\u0430\u0445",
        name: "\u043A\u043E\u0434",
        openText: "\u0414\u044D\u043B\u0433\u044D\u0445"
      },
      collapsible: {
        closeText: "\u041D\u0443\u0443\u0445",
        name: "\u0448\u0438\u043D\u0436 \u0447\u0430\u043D\u0430\u0440\u0443\u0443\u0434",
        openText: "\u0425\u0430\u0440\u0443\u0443\u043B\u0430\u0445"
      },
      pre: {
        copy: "\u041A\u043E\u0434\u044B\u0433 \u0441\u0430\u043D\u0430\u0445 \u043E\u0439\u0434 \u0445\u0443\u0443\u043B\u0430\u0445"
      }
    },
    selectMenu: {
      create: '"{label}" \u04AF\u04AF\u0441\u0433\u044D\u0445',
      noData: "\u041C\u044D\u0434\u044D\u044D\u043B\u044D\u043B \u0431\u0430\u0439\u0445\u0433\u04AF\u0439",
      noMatch: "\u0422\u043E\u0445\u0438\u0440\u043E\u0445 \u043C\u044D\u0434\u044D\u044D\u043B\u044D\u043B \u043E\u043B\u0434\u0441\u043E\u043D\u0433\u04AF\u0439",
      search: "\u0425\u0430\u0439\u0445..."
    },
    slideover: {
      close: "\u0425\u0430\u0430\u0445"
    },
    table: {
      noData: "\u041C\u044D\u0434\u044D\u044D\u043B\u044D\u043B \u0431\u0430\u0439\u0445\u0433\u04AF\u0439"
    },
    toast: {
      close: "\u0425\u0430\u0430\u0445"
    }
  }
});
